
export default {
  layout: 'userpage',
  props: ['error'] // you can set a custom layout for the error page
}
